import { Reducer } from "redux";
import { Action, ActionType } from "../../../actions";
import { RemarksFiltersData } from "../../../state/BookingCreateManagerV2/Remarks/FiltersData";

const updateRemarksFiltersData: Reducer<RemarksFiltersData> = (
  state: RemarksFiltersData = new RemarksFiltersData(),
  action: Action<ActionType, RemarksFiltersData>
) => {
  switch (action.type) {
    case ActionType.BOOKING_CREATE_MANAGER_V2_REMARKS_FILTERS_UPDATED:
      return { ...state, ...action.data };
    case ActionType.BOOKING_CREATE_MANAGER_V2_REMARKS_FILTERS_RESET:
      return new RemarksFiltersData();
    default:
      return state;
  }
};

export default updateRemarksFiltersData;
